<template>
  <div
    v-if="game"
    :class="{
      'text-white': theme === 'dark',
      'text-black': theme === 'light'
    }"
    class="sidearm-mm-matchup-bracket flex flex-align-center"
  >
    <div class="flex-item-auto">
      <div class="logo-line flex flex-align-center">
        <div v-if="game.location_indicator === 'A'">
          <img
            :src="$root.school_logo(size, size)"
            :alt="
              $root.data.school.name ? $root.data.school.name : 'School Logo'
            "
          />
        </div>
        <div v-else>
          <img
            :src="
              game.opponent && game.opponent.image && game.opponent.image.url
                ? `${$root.absolutize_cdn(
                    game.opponent.image.url
                  )}?width=${size}&height=${size}`
                : `${$root.school_logo(size, size)}&s.grayscale=100`
            "
            :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
          />
        </div>

        <div
          v-if="showSeeds && has_both_seeds"
          :style="{
            fontSize: `${size / 3 / 16}rem`
          }"
          class="font-abolition mx-1"
        >
          #{{
            game.location_indicator === "A"
              ? $root.data.team.seed
              : game.opponent.seed
          }}
        </div>

        <div
          :style="{
            backgroundColor: theme === 'dark' ? 'white' : 'black',
            width: `${size / 2}px`
          }"
          class="horizontal flex-item-1"
        ></div>
      </div>

      <div
        :class="{
          'opacity-0': !showIndicator
        }"
        class="indicator text-bold text-uppercase text-center"
      >
        vs
      </div>

      <div class="logo-line flex flex-align-center">
        <div v-if="game.location_indicator !== 'A'">
          <img
            :src="$root.school_logo(size, size)"
            :alt="
              $root.data.school.name ? $root.data.school.name : 'School Logo'
            "
          />
        </div>
        <div v-else>
          <img
            :src="
              game.opponent && game.opponent.image && game.opponent.image.url
                ? `${$root.absolutize_cdn(
                    game.opponent.image.url
                  )}?width=${size}&height=${size}`
                : `${$root.school_logo(size, size)}&s.grayscale=100`
            "
            :alt="game.opponent ? game.opponent.title : 'Opponent Logo'"
          />
        </div>

        <div
          v-if="showSeeds && has_both_seeds"
          :style="{
            fontSize: `${size / 3 / 16}rem`
          }"
          class="font-abolition mx-1"
        >
          #{{
            game.location_indicator !== "A"
              ? $root.data.team.seed
              : game.opponent.seed
          }}
        </div>

        <div
          :style="{
            backgroundColor: theme === 'dark' ? 'white' : 'black',
            width: `${size / 2}px`
          }"
          class="horizontal flex-item-1"
        ></div>
      </div>
    </div>

    <div class="flex-align-self-stretch flex flex-align-center">
      <div
        :style="{
          backgroundColor: theme === 'dark' ? 'white' : 'black',
          height: `calc(100% - ${size}px)`
        }"
        class="vertical"
      ></div>
    </div>

    <div
      :style="{
        backgroundColor: theme === 'dark' ? 'white' : 'black'
      }"
      class="divider flex-item-1"
    ></div>

    <slot class="flex-item-auto" />
  </div>
</template>

<script>
export default {
  props: {
    round: { type: [Object, null], required: true },
    showIndicator: { type: Boolean, required: false, default: false },
    showSeeds: { type: Boolean, required: false, default: false },
    size: { type: Number, required: false, default: 72 },
    theme: { type: String, required: false, default: "dark" }
  },
  computed: {
    game() {
      if (!this.round) {
        return null;
      }
      return this.round.game;
    },
    has_both_seeds() {
      return (
        this.$root.data.team &&
        this.$root.data.team.seed &&
        this.game.opponent &&
        this.game.opponent.seed &&
        +this.game.opponent.seed <= 16
      );
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.#{$prefix}-matchup-bracket {
  .horizontal {
    height: 1px;
  }

  .indicator {
    font-size: 3rem;
    font-family: $font-abolition;
  }

  .vertical {
    width: 1px;
  }

  .divider {
    height: 1px;
    min-width: grid_percent(120);
  }
}
</style>
